import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import { Button, Dropdown, Grid, Icon, InputText, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { StatusStateEnum } from "~/types/enums";
import AiAssistantChat from "~/components/AiAssistantChat";
import { useDispatch, useSelector } from "react-redux";
import aiQueriesActionCreators from "~/store/aiQueries/actions";
import aiQuerySelectors from "~/store/aiQueries/selectors";
const DropdownList = styled(Dropdown.List)`
  min-height: 80vh;
  max-height: 80vh;
  width: 768px;
  display: flex;
  flex-direction: column;
`;
const StyledButton = styled(Button)`
  transition: transform 200ms ease-in-out, box-shadow 100ms ease-in-out;
  background-color: transparent;
  width: 56px;
  height: 56px;
  background-image: ${_ref => {
  let {
    theme
  } = _ref;
  return `linear-gradient(65deg, ${theme.colors.background.secondary}, ${theme.colors.background.secondary}), linear-gradient(145deg, ${theme.colors.primary.light}, ${theme.colors.primary.dark}, ${theme.colors.primary.main})`;
}};
  background-clip: padding-box, border-box;
  background-origin: border-box;
  border: 12px solid transparent;
  border-radius: 50%;
  &:hover {
    transform: scale(1.1);
  }
`;
const AiIcon = styled.span`
  width: 1.6em;
  height: 1.6em;
  margin-right: 0.8em;
  display: block;
  background-image: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return `linear-gradient(65deg, ${theme.colors.borders.primary}, ${theme.colors.borders.primary}), linear-gradient(145deg, ${theme.colors.primary.light}, ${theme.colors.primary.dark}, ${theme.colors.primary.main})`;
}};
  background-clip: padding-box, border-box;
  background-origin: border-box;
  border: 5px solid transparent;
  border-radius: 50%;
`;
const TopBar = styled(Grid)`
  position: sticky;
  top: 0;
  z-index: 2;
`;
const Content = styled.div`
  flex-grow: 1;
`;
const BottomBar = styled.div`
  background: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.background.primary;
}};
  z-index: 2;
`;
const AiAssistantDropdown = _ref4 => {
  let {
    direction = "topLeft",
    ...rest
  } = _ref4;
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const [query, setQuery] = useState("");
  const status = useSelector(aiQuerySelectors.getStatusByQuery("+"));
  const handleSubmit = () => {
    dispatch(aiQueriesActionCreators.createStarted({
      query
    }, data => {
      if (data) {
        setQuery("");
      }
    }));
  };
  const handleExample = text => {
    setQuery(text);
    dispatch(aiQueriesActionCreators.createStarted({
      query: text
    }, data => {
      if (data) {
        setQuery("");
      }
    }));
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    direction: direction,
    customHandler: (toggle, isOpen) => /*#__PURE__*/React.createElement(StyledButton, _extends({
      onClick: e => toggle(e),
      outline: false,
      color: "translucent",
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("AiAssistantDropdown.yourPersonalAiAssistant"),
      isOpen: isOpen,
      rounded: true,
      s: {
        p: 0
      }
    }, rest)),
    fullWidth: true
  }, _ref5 => {
    let {
      isOpen,
      onItemClick
    } = _ref5;
    return /*#__PURE__*/React.createElement(DropdownList, {
      isOpen: isOpen,
      style: {
        marginBottom: "-50px"
      }
    }, /*#__PURE__*/React.createElement(TopBar, {
      cols: 2,
      template: "1fr auto",
      s: {
        pl: 6,
        pr: 4,
        pt: 6,
        pb: 0
      },
      align: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      element: "span",
      fontSize: 8,
      weight: "semiBold",
      display: "block"
    }, t("AiAssistantDropdown.askBase"), /*#__PURE__*/React.createElement(Text, {
      element: "span",
      color: "textSecondary",
      fontSize: 4,
      s: {
        ml: 2
      }
    }, t("AiAssistantDropdown.yourAiAssistant"))), /*#__PURE__*/React.createElement(Button, {
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("common.actions.close"),
      onClick: () => onItemClick(),
      color: "transparent",
      rounded: true,
      s: {
        p: 2,
        mx: 0.5
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      scale: 5,
      src: "cross",
      color: theme.colors.text.secondary,
      display: "block"
    }))), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(AiAssistantChat, {
      onRequest: handleExample
    })), /*#__PURE__*/React.createElement(BottomBar, null, /*#__PURE__*/React.createElement("form", {
      onSubmit: e => {
        e.stopPropagation();
        e.preventDefault();
        handleSubmit();
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      template: "1fr auto",
      gap: 3,
      s: {
        px: 6,
        py: 4
      },
      align: "center"
    }, /*#__PURE__*/React.createElement(InputText, {
      value: query,
      onChange: setQuery,
      elemBefore: /*#__PURE__*/React.createElement(AiIcon, null),
      elemAfter: /*#__PURE__*/React.createElement(Button, {
        color: "transparent",
        s: {
          p: 1.5,
          mr: -2.5,
          ml: 1
        },
        loading: status === StatusStateEnum.LOADING,
        disabled: !query,
        onClick: handleSubmit,
        rounded: true
      }, /*#__PURE__*/React.createElement(Icon, {
        scale: 6,
        src: "send",
        color: theme.colors.primary.main,
        display: "block"
      })),
      placeholder: "Ask me something",
      rounded: true,
      clearButton: true,
      autoFocus: true
    })))));
  });
};
export default AiAssistantDropdown;